import { render } from "./AboutIframe.vue?vue&type=template&id=c5ac7080&ts=true"
import script from "./AboutIframe.ts?vue&type=script&lang=ts&external"
export * from "./AboutIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__